import React from 'react'
import axios from 'axios'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { connect } from 'react-redux'
import FlowView from 'components/core/FlowView'
import { ContentHeader, StaticBox, FlowTable, BigModal } from 'components/basic'

class About extends FlowView {
  constructor (props) {
    super(props, 'About Flow')
    this.state = {
      licences: [],
      modalState: false,
      license: {}
    }
  }
  async componentDidMount () {
    var err, res
    [err, res] = await axios.request({
      url: '/config/licences.json',
      method: 'get',
      headers: {
        'Cache-Control': 'no-cache'
      }
    }).then(res => {
      return [null, res]
    }).catch(err => [err])
    if (err) return
    this.setState({licences: res.data.sort((a, b) => a.name.localeCompare(b.name))})
  }
  openLicense (license) {
    this.setState({
      license: license,
      modalState: true
    })
  }
  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Flow' subtitle='About' />
        <hr />
        <div className='row'>
          <Tabs selectedTabClassName='active'>
            <div className='col-md-12'>
              <TabList className='nav nav-tabs nav-tabs-white'>
                <Tab><a>About Flow</a></Tab>
                <Tab><a>Licences</a></Tab>
                <Tab><a>Versions</a></Tab>
              </TabList>
            </div>
            <TabPanel className='tab-pane'>
              <StaticBox icon='globe' title='About Flow'>
                <p>Flow is an integration and automation platform, developed and maintained by <a target='_blank' href='http://www.maintrac.se'>Maintrac AB.</a></p>
                <div style={{paddingLeft: '20px'}}>
                  <p>Version: </p>
                  <p>License key: </p>
                  <p>Support: <a href='mailto:flow-support@maintrac.se'>flow-support@maintrac.se</a></p>
                </div>
              </StaticBox>
            </TabPanel>
            <TabPanel className='tab-pane'>
              <StaticBox icon='code' title='Licences & Libraries'>
                <FlowTable data={this.state.licences.map(license => [license.name, license.description, <a onClick={e => this.openLicense(license)} className='btn btn-sm btn-primary'>{license.license} <i className='fa fa-fw fa-external-link' /></a>])}>
                  <tr>
                    <th>Library</th>
                    <th>Description</th>
                    <th>License</th>
                  </tr>
                </FlowTable>
              </StaticBox>
            </TabPanel>
            <TabPanel className='tab-pane'>
              <StaticBox icon='code' title='Versions' />
            </TabPanel>
          </Tabs>
        </div>
        <BigModal buttons={[{text: 'Close', event: () => this.setState({modalState: false})}]} title={this.state.license.name} isOpen={this.state.modalState} close={e => this.setState({modalState: false})}>
          <div className='col-md-12'>
            <pre>{this.state.license.license_text}</pre>
          </div>
        </BigModal>
      </div>
    )
  }
}
// eslint-disable-next-line
About = connect(state => state.siteReducer)(About)
export default About



// WEBPACK FOOTER //
// ./src/views/core/about.js